(ns common.schema.entities.task
  (:require
   [common.schema.option-filters :as option-filters]
   [common.schema.entities.common :as common-schema]
   [common.schema.entities.related-entities :as related-entities]
   [common.schema.schema-utils :as su]
   [common.schema.entities.integration.ai-options :as ai-options]
   [common.schema.entities.task-type :as task-type]))

(def schema
  (vec (concat
        (su/text-edn-field :task/data "Data" {:default-field-visibility :in-use-disabled})
        (su/text-simple-field :task/title "Title" {:default-field-visibility :in-use-disabled})
        (su/keyword-field :task/type
                          "Type"
                          task-type/options
                          {:editor-type   :editor.type/none
                           :authorization su/access-system-ssg
                           :default-field-visibility :in-use-disabled})
        (su/datetime-field :task/created "Created on" {:default-field-visibility :in-use-disabled})
        (su/single-ref-field :task/target
                             "Target"
                             nil
                             {:editor-type :editor.type/none
                              :default-field-visibility :in-use-disabled})
        (su/multi-ref-field :task/relates
                            "Related to"
                            nil
                            {:editor-type :editor.type/none
                             :default-field-visibility :in-use-disabled})
        (su/text-simple-field :task/source
                              "Source"
                              {:editor-type :editor.type/none
                               :default-field-visibility :in-use-disabled})
        (su/keyword-field :task/ai-processing-status
                          "AI processing status"
                          ai-options/status-options
                          {:editor-type :editor.type/none
                           :authorization su/access-system-user
                           :default-field-visibility :in-use-disabled})
        (su/option-field-multi :task/tag
                               "Tags"
                               {:default-field-visibility :in-use-disabled
                                :authorization su/access-bsg-bsg})

        [[:task/assignee
          {:field/data-type          :data.type/ref-single
           :field/not-clearable?     true
           :value-type               :entity
           :field/entity-types       [:entity.type/account]
           :field/option-filter-fn   option-filters/active-users
           :field/os-filter-terms-fn    (fn [{:keys [] :as args}]
                                          {"extras.active-user" true})
           :field/default-visibility {:editor :editor.type/select
                                      :grid   :editor.type/select
                                      :filter :filter.type/select
                                      :field-visibility :in-use-disabled}
           :field/default-authorization {:access/read  :role/guest-buy-side
                                         :access/write :role/guest-buy-side}
           :field/translations       {:en "Owner"}}]
         [:task/assigner
          {:field/data-type          :data.type/ref-single
           :field/not-clearable?     true
           :value-type               :entity
           :field/entity-types       [:entity.type/account]
           :field/option-filter-fn   option-filters/active-users
           :field/os-filter-terms-fn    (fn [{:keys [] :as args}]
                                          {"extras.active-user" true})
           :field/default-visibility {:editor :editor.type/select
                                      :grid   :editor.type/select
                                      :filter :filter.type/select
                                      :field-visibility :in-use-disabled}
           :field/default-authorization {:access/read  :role/guest-buy-side
                                         :access/write :role/guest-buy-side}
           :field/translations       {:en "Assigner"}}]
         [:task/due
          {:field/data-type          :data.type/datetime
           :field/constraints        {}
           :field/default-visibility {:editor :editor.type/date
                                      :grid   :editor.type/date
                                      :filter :filter.type/date
                                      :field-visibility :in-use-disabled}
           :field/default-authorization {:access/read  :role/guest-buy-side
                                         :access/write :role/guest-buy-side}
           :field/translations       {:en "Due"}}]
         [:task/completed?
          {:field/data-type          :data.type/boolean
           :field/default-authorization {:access/read  :role/guest-buy-side
                                         :access/write :role/guest-buy-side}
           :field/default-visibility {:editor :editor.type/toggle
                                      :grid   :editor.type/toggle
                                      :filter :filter.type/boolean
                                      :field-visibility :in-use-disabled}
           :field/translations       {:en "Completed"}}]
         [:task/message
          {:field/data-type          :data.type/text-richtext
           :field/default-authorization {:access/read  :role/guest-buy-side
                                         :access/write :role/guest-buy-side}
           :field/default-visibility {:editor :editor.type/none
                                      :grid   :editor.type/wysiwyg
                                      :filter :filter.type/text
                                      :field-visibility :in-use-disabled}
           :field/translations       {:en "Task description"}}]
         [:task/resolve-status
          {:field/data-type          :data.type/keyword
           :field/default-authorization {:access/read  :role/guest-buy-side
                                         :access/write :role/guest-buy-side}
           :field/default-visibility {:editor :editor.type/none
                                      :grid   :editor.type/none
                                      :filter :filter.type/none
                                      :field-visibility :in-use-disabled}
           :field/translations       {:en "Resolve status"}}]
         [:task/resolved-data
          {:field/data-type          :data.type/text-edn
           :field/default-authorization {:access/read      :role/guest-buy-side
                                         :access/write     :role/guest-buy-side}
           :field/default-visibility {:editor :editor.type/none
                                      :grid   :editor.type/none
                                      :filter :filter.type/none
                                      :field-visibility :in-use-disabled}
           :field/translations       {:en "Resolved data"}}]

         common-schema/team-members-field]
        related-entities/related-entities)))
